import { useTheme } from '@emotion/react';
import { useIsSSR } from 'react-aria';
import { useBreakpointContext } from './breakpoint-context.js';
import { useMediaQuery } from './use-media-query.js';

/**
 * Hook to generate a map of all breakpoints, indicating their current status as either active or
 * inactive.
 */ function useBreakpoints() {
    return new Map([
        [
            'xs',
            useMediaQueryMatches('xs')
        ],
        [
            'sm',
            useMediaQueryMatches('sm')
        ],
        [
            'md',
            useMediaQueryMatches('md')
        ],
        [
            'lg',
            useMediaQueryMatches('lg')
        ],
        [
            'xl',
            useMediaQueryMatches('xl')
        ]
    ]);
}
/**
 * Hook to determine whether the given breakpoint is currently active, while taking server-side
 * rendering into account.
 *
 * @param token - The breakpoint token to check.
 */ function useMediaQueryMatches(token) {
    const tokens = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ];
    const theme = useTheme();
    const ssr = useIsSSR();
    const serverBreakpoint = useBreakpointContext();
    const activeOnClient = useMediaQuery(`(min-width: ${theme.breakpoints[token]}px)`);
    const activeOnServer = !!serverBreakpoint && tokens.indexOf(token) <= tokens.indexOf(serverBreakpoint);
    return ssr ? activeOnServer : activeOnClient;
}

export { useBreakpoints };
//# sourceMappingURL=use-breakpoints.js.map
